import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { label: "Hizmetler", href: "#hizmetler", testid: "nav-link-services" },
  { label: "Manifesto", href: "#manifesto", testid: "nav-link-manifesto" },
  { label: "İşler", href: "#isler", testid: "nav-link-work" },
  { label: "İletişim", href: "#iletisim", testid: "nav-link-contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const go = (href) => {
    setOpen(false);
    setTimeout(() => scrollToId(href), open ? 350 : 0);
  };

  return (
    <>
      <motion.header
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2, ease: [0.33, 1, 0.68, 1] }}
        className="glass-panel fixed inset-x-0 top-0 z-50"
        data-testid="navbar"
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
          <button
            data-testid="nav-logo"
            onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
            className="font-display text-xl font-extrabold tracking-tight text-zinc-100"
          >
            REYA<span className="text-gold">©</span>DESING
          </button>

          <nav className="hidden items-center gap-8 md:flex">
            {LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={l.testid}
                onClick={() => go(l.href)}
                className="group relative font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 transition-colors duration-300 hover:text-gold"
              >
                {l.label}
                <span className="absolute -bottom-1 left-0 h-px w-0 bg-gold transition-[width] duration-300 group-hover:w-full" />
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              data-testid="nav-quote-btn"
              onClick={() => go("#iletisim")}
              className="group hidden items-center gap-2 rounded-full bg-gold px-5 py-2.5 font-display text-sm font-bold text-obsidian transition-transform duration-300 hover:scale-105 sm:flex"
            >
              Teklif Al
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
            </button>
            <button
              data-testid="nav-mobile-menu-btn"
              onClick={() => setOpen(!open)}
              className="rounded-full border border-gold/20 p-2.5 text-zinc-100 md:hidden"
              aria-label="Menü"
            >
              {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </div>
      </motion.header>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ opacity: 0, y: "-4%" }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: "-4%" }}
            transition={{ duration: 0.35, ease: [0.33, 1, 0.68, 1] }}
            className="fixed inset-0 z-40 flex flex-col justify-center bg-obsidian/95 px-8 backdrop-blur-2xl md:hidden"
          >
            {LINKS.map((l, i) => (
              <div key={l.href} className="overflow-hidden">
                <motion.button
                  initial={{ y: "110%" }}
                  animate={{ y: 0 }}
                  transition={{ duration: 0.6, delay: 0.08 * i, ease: [0.33, 1, 0.68, 1] }}
                  data-testid={`mobile-${l.testid}`}
                  onClick={() => go(l.href)}
                  className="block w-full py-4 text-left font-display text-4xl font-extrabold text-zinc-100 transition-colors duration-300 hover:text-gold"
                >
                  <span className="mr-4 font-mono text-sm text-gold">0{i + 1}</span>
                  {l.label}
                </motion.button>
              </div>
            ))}
            <motion.button
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.45 }}
              data-testid="mobile-nav-quote-btn"
              onClick={() => go("#iletisim")}
              className="mt-10 w-fit rounded-full bg-gold px-8 py-4 font-display text-lg font-bold text-obsidian"
            >
              Teklif Al
            </motion.button>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
